import React from 'react';
import './ChinSpacing.css';

const ChinSpacing = () => <div className="ChinSpacing" />;

export default ChinSpacing;
